const $ = jQuery

export default function Filters () {
  const LOADER = $('#loader-overlay')

  //////////////////////////////////////
  //////// BUILDING GROUNDS OLD ////////
  //////////////////////////////////////

  // Consts
  const POST_PAGINATION = '#building-grounds-pagination ul li a'
  const POST_DEST = $('#building-grounds-destination')
  const POST_PAGINATION_DEST = $('#building-grounds-pagination')

  // Lets
  let post_page_number = 0

  // Click on pagination
  $(document).on('click', POST_PAGINATION, function (e) {
    // Prevent default link behavior
    e.preventDefault()

    // Update page number
    post_page_number = parseInt($(this).attr('data-page'))

    // Run ajax request
    getBuildingGrounds()
  })

  // Ajax request function
  function getBuildingGrounds () {
    // Show loader
    LOADER.addClass('show')

    // Animate body to top
    $('html, body').animate({
      scrollTop: POST_DEST.offset().top - 100
    }, 500)

    // Set ajax data
    const data = {
      action: 'filter_building_grounds',
      page_number: post_page_number,
      url: window.location.href
    }

    // Ajax call
    jQuery.post(main_theme_objects.ajax_url, data, function (response) {
      if (response != 0) {
        // Post response
        POST_DEST.html(response.posts)

        // Pagination response
        POST_PAGINATION_DEST.html(response.pagination)

        // Hide loader
        LOADER.removeClass('show')
      }
    })
  }

  /// ///////////////////////////////////
  /// /////// BUILDING GROUNDS //////////
  /// ///////////////////////////////////

  // Consts
  const BUILDING_PAGINATION = '#building-ground-pagination ul li a'
  const CITIES_PAGINATION = '#cities-pagination ul li a'
  const BUILDING_DEST = $('#building-ground-destination')
  const BUILDING_PAGINATION_DEST = $('#building-ground-pagination')
  const CITIES_PAGINATION_DEST = $('#cities-pagination')

  // Lets
  let building_page_number = 0

  // Click on pagination
  $(document).on('click', BUILDING_PAGINATION, function (e) {
    // Prevent default link behavior
    e.preventDefault()

    // Update page number
    building_page_number = parseInt($(this).attr('data-page'))

    // Run ajax request
    getBuildingGround()
  })

  // Click on pagination
  $(document).on('click', CITIES_PAGINATION, function (e) {
    // Prevent default link behavior
    e.preventDefault()

    // Update page number
    building_page_number = parseInt($(this).attr('data-page'))

    // Run ajax request
    getCities()
  })

  // Ajax request function
  function getCities () {
    // Show loader
    LOADER.addClass('show')

    // Animate body to top
    $('html, body').animate({
      scrollTop: BUILDING_DEST.offset().top - 100
    }, 500)

    // Set ajax data
    const data = {
      action: 'filter_cities',
      page_number: building_page_number,
      url: window.location.href
    }

    // Ajax call
    jQuery.post(main_theme_objects.ajax_url, data, function (response) {
      if (response != 0) {
        // Post response
        BUILDING_DEST.html(response.posts)

        // Pagination response
        CITIES_PAGINATION_DEST.html(response.pagination)

        // Hide loader
        LOADER.removeClass('show')
      }
    })
  }

  // Ajax request function
  function getBuildingGround () {
    // Show loader
    LOADER.addClass('show')

    // Animate body to top
    $('html, body').animate({
      scrollTop: BUILDING_DEST.offset().top - 100
    }, 500)

    // Set ajax data
    const data = {
      action: 'filter_building_ground',
      page_number: building_page_number,
      url: window.location.href,
      term_id: BUILDING_DEST.hasClass('is-term') ? BUILDING_DEST.attr('data-term-id') : false
    }

    // Ajax call
    jQuery.post(main_theme_objects.ajax_url, data, function (response) {
      if (response != 0) {
        // Post response
        BUILDING_DEST.html(response.posts)

        // Pagination response
        BUILDING_PAGINATION_DEST.html(response.pagination)

        // Hide loader
        LOADER.removeClass('show')
      }
    })
  }

  /// ///////////////////////////////////
  /// ///////////// JOBS ////////////////
  /// ///////////////////////////////////

  // Consts
  const JOBS_BUTTON = '#fetch-more-jobs'
  const JOBS_DEST = $('#jobs-destination')
  const JOBS_SELECT = $('#jobs-select')

  // Lets
  let page = 0
  let type = ''

  // Click on load more button
  $(document).on('click', JOBS_BUTTON, function (e) {
    // Prevent default link behavior
    e.preventDefault()

    // Update page number
    page = parseInt($(this).attr('data-page'))
    // Run ajax request
    loadMoreJobs()
  })

  // Change job type
  $(JOBS_SELECT).change(function (e) {
    // Prevent default link behavior
    e.preventDefault()

    // Update page number
    page = 1
    type = $(this).find(':selected').val()
    // Run ajax request
    filterJobs()
  })

  // Ajax request function
  function filterJobs () {
    // Show loader
    LOADER.addClass('show')

    // Set ajax data
    const data = {
      action: 'filter_jobs',
      type: type,
      url: window.location.href
    }

    // Ajax call
    jQuery.post(main_theme_objects.ajax_url, data, function (response) {
      if (response != 0) {
        // Post response
        JOBS_DEST.html(response.posts)

        if (!type) {
          $(JOBS_BUTTON).attr('data-page', 2)
          $(JOBS_BUTTON).show()
        } else {
          $(JOBS_BUTTON).hide()
        }

        // Hide loader
        LOADER.removeClass('show')
      }
    })
  }

  // Ajax request function
  function loadMoreJobs () {
    // Show loader
    LOADER.addClass('show')

    // Set ajax data
    const data = {
      action: 'load_more_jobs',
      page: page,
      url: window.location.href
    }

    // Ajax call
    jQuery.post(main_theme_objects.ajax_url, data, function (response) {
      if (response != 0) {
        // Post response
        JOBS_DEST.append(response.posts)

        if (response.pages === page) {
          $(JOBS_BUTTON).hide()
        } else {
          $(JOBS_BUTTON).attr('data-page', parseInt(page) + 1)
        }

        // Hide loader
        LOADER.removeClass('show')
      }
    })
  }
}
